function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E8594F"
    },
    cx: 241.131,
    cy: 270.87,
    r: 203.942
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFEFEF"
    },
    d: "M241.131,414.827c-79.379,0-143.959-64.58-143.959-143.959s64.58-143.959,143.959-143.959 S385.09,191.49,385.09,270.868S320.51,414.827,241.131,414.827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8594F"
    },
    d: "M241.131,354.844c-46.306,0-83.976-37.672-83.976-83.976s37.67-83.976,83.976-83.976 s83.976,37.672,83.976,83.976S287.436,354.844,241.131,354.844z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4AD47"
    },
    points: "502.403,60.494 455.747,56.252 451.505,9.597 399.76,61.343 404.85,107.15 450.657,112.239  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M449.596,121.778c0.355,0.04,0.709,0.059,1.062,0.059c2.529,0,4.975-1.002,6.785-2.811l51.746-51.745 c2.632-2.633,3.505-6.551,2.237-10.053s-4.447-5.954-8.155-6.291l-38.691-3.517l-3.519-38.691c-0.336-3.708-2.789-6.887-6.29-8.154 c-3.501-1.267-7.42-0.396-10.054,2.237l-51.746,51.746c-2.061,2.061-3.075,4.949-2.752,7.847l4.58,41.223l-9.69,9.69 c-35.788-32.737-82.728-53.464-134.382-55.76V39.335c0-5.3-4.297-9.597-9.597-9.597s-9.597,4.297-9.597,9.597v18.22 c-110.125,4.896-198.819,93.59-203.716,203.716H9.597c-5.3,0-9.597,4.297-9.597,9.597s4.297,9.597,9.597,9.597h18.22 c4.897,110.126,93.591,198.819,203.716,203.716v18.22c0,5.3,4.297,9.597,9.597,9.597s9.597-4.297,9.597-9.597v-18.22 c110.125-4.896,198.819-93.59,203.716-203.716h18.22c5.3,0,9.597-4.297,9.597-9.597s-4.297-9.597-9.597-9.597h-18.22 c-2.296-51.654-23.023-98.594-55.759-134.384l9.69-9.69L449.596,121.778z M443.802,30.872l2.387,26.25 c0.42,4.614,4.074,8.269,8.688,8.689l26.25,2.386l-33.995,33.995l-33.593-3.732l-3.732-33.592L443.802,30.872z M435.236,261.271 h-13.521c-5.3,0-9.597,4.297-9.597,9.597s4.297,9.597,9.597,9.597h13.521c-4.865,99.541-84.967,179.644-184.508,184.508v-13.52 c0-5.3-4.297-9.597-9.597-9.597s-9.597,4.297-9.597,9.597v13.52c-99.541-4.865-179.644-84.968-184.508-184.508h13.521 c5.3,0,9.597-4.297,9.597-9.597s-4.297-9.597-9.597-9.597H47.025c4.865-99.54,84.967-179.644,184.508-184.508v13.52 c0,5.3,4.297,9.597,9.597,9.597s9.597-4.297,9.597-9.597v-13.52c46.366,2.266,88.513,20.855,120.805,50.13l-28.878,28.878 c-27.083-23.919-62.635-38.459-101.525-38.459c-84.671,0-153.556,68.884-153.556,153.556s68.885,153.556,153.556,153.556 s153.556-68.884,153.556-153.556c0-38.889-14.54-74.441-38.457-101.526l28.878-28.878 C414.382,172.758,432.97,214.906,435.236,261.271z M234.344,277.655c1.875,1.874,4.33,2.811,6.786,2.811 c2.457,0,4.913-0.937,6.786-2.811l52.12-52.12c9.688,12.56,15.472,28.281,15.472,45.334c0,41.013-33.366,74.379-74.379,74.379 s-74.379-33.366-74.379-74.379s33.366-74.379,74.379-74.379c17.053,0,32.773,5.784,45.334,15.472l-52.12,52.12 C230.597,267.831,230.597,273.907,234.344,277.655z M300.125,198.302c-16.11-13.121-36.645-21.006-58.994-21.006 c-51.597,0-93.573,41.977-93.573,93.573s41.976,93.573,93.573,93.573s93.573-41.977,93.573-93.573 c0-22.348-7.885-42.884-21.006-58.994l28.942-28.942c20.457,23.583,32.853,54.338,32.853,87.935 c0,74.087-60.274,134.361-134.361,134.361s-134.361-60.274-134.361-134.361s60.274-134.361,134.361-134.361 c33.596,0,64.353,12.396,87.936,32.853L300.125,198.302z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.c7a3e717.svg";
export { ForwardRef as ReactComponent };